import { render, staticRenderFns } from "./LeaderData.vue?vue&type=template&id=380c9e9b&"
import script from "./LeaderData.vue?vue&type=script&lang=js&"
export * from "./LeaderData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports